import { Icons, ExternalLink, Stack, tokens } from '@cast/design-system';

import { HpaSettingsBanner } from 'features/cluster/workload-optimization/_components/HpaSettingsBanner';

import { getDocsLink } from '@cast/utils';

export const HpaNotSupportedMessage = () => {
  return (
    <HpaSettingsBanner
      testId="hpa-not-supported-message"
      hexIcon={{
        Icon: <Icons.Question weight="fill" />,
        size: 50,
        iconColor: tokens.theme.fg.status.onNeutralSubtle,
        hexColor: tokens.theme.bg.status.neutralSubtle,
      }}
      title="Horizontal optimization not supported"
      description={
        <Stack alignItems="center" gap={4}>
          <span>This workload type cannot be scaled horizontally.</span>
          <ExternalLink
            link={getDocsLink('docs_woop_hpa')}
            sx={{ typography: 'P12R' }}
          >
            Documentation
          </ExternalLink>
        </Stack>
      }
    />
  );
};
